
import { defineComponent } from "vue";

export default defineComponent({
  name: "HeroSection1",
  components: {},
});
